import baseAPI from "@/http";

const router = "api/dashboard";

export const dashboardAPI = {
  totalInscricao2023: (filters) =>
    baseAPI.post(`${router}/obter-total-inscricoes-2023`, filters),
  totalInscricao2024: (filters) =>
    baseAPI.post(`${router}/obter-total-inscricoes-2024`, filters),
  totalInscricao2025: (filters) =>
    baseAPI.post(`${router}/obter-total-inscricoes-2025`, filters),
  comparacaoAno: (filters) =>
    baseAPI.post(`${router}/comparacao-ano-inscricao-sala`, filters),
  obterTotais: (filters) => baseAPI.post(`${router}/obter-totais`, filters),
  comparacaoAnoParceiro: (filters) =>
    baseAPI.post(`${router}/comparacao-ano-inscricao-parceiro`, filters),
  getTabela: (filters) => baseAPI.post(`${router}/obter-inscritos`, filters),
  gerarXls: (filters) =>
    baseAPI.post(`${router}/gerar-excel-inscritos`, filters, {
      responseType: "blob",
    }),
};
